<template>
<div id="SearchSlip" class="">
  <b-navbar toggleable="sm" type="light" variant="light">
    <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

    <b-navbar-brand><f-icon icon="file-invoice"></f-icon> ระบบเรียกดูใบเสร็จรับเงินและใบแจ้งการคืนเงิน</b-navbar-brand>

    <b-navbar-nav class="ml-auto">
      <b-button class="my-2 my-sm-0" @click="$router.push('/StaffLogin')"><f-icon icon="sign-out-alt"></f-icon> Sign Out</b-button>
    </b-navbar-nav>
  </b-navbar>
  <b-container fluid>
    <b-row>
      <b-col  lg="11" class="form-login mx-auto mb-3">

        <b-card no-body>
          <b-tabs card>
            <b-tab title="ใบเสร็จรับเงินนักศึกษาค้างชำระ (Receipt)" active>
              <b-card-text>
                <b-card sub-title="รายละเอียดการค้นหา" border-variant="primary">
                  <b-row>
                    <b-col md="3">
                      <div class="form-label-group">
                        <b-form-input placeholder="placeholder" id="form_stdname" autocomplete="off" class="mb-2" v-model="form.fname" type="text"></b-form-input>
                        <label for="form_stdname" class="mb-1">ชื่อจริง</label>
                      </div>
                    </b-col>
                    <b-col md="3">
                      <div class="form-label-group">
                        <!-- :state="telState" aria-describedby="input-live-feedback" -->
                        <b-form-input placeholder="placeholder" id="form_stdname" autocomplete="off" class="mb-2" v-model="form.lname" type="text"></b-form-input>
                        <label for="form_tel" class="mb-1">นามสกุล</label>
                      </div>
                    </b-col>
                    <b-col md="3">
                      <div class="form-label-group">
                        <b-form-input placeholder="placeholder" id="form_idstd" autocomplete="off" class="mb-2" v-model="form.sid" type="tel"></b-form-input>
                        <label for="form_idstd" class="mb-1">รหัสนักศึกษา</label>
                        <!-- <b-form-text id="input-live-help">หากข้อมูลไม่ถูกต้องกรุณาติดต่อฝ่ายทะเบียน</b-form-text> -->
                      </div>
                    </b-col>
                    <b-col md="3">
                      <div class="form-label-group">
                        <!-- :state="telState" aria-describedby="input-live-feedback" -->
                        <b-form-input placeholder="placeholder" id="form_tel" autocomplete="off" class="mb-2" v-model="form.cid" type="tel"></b-form-input>
                        <label for="form_tel" class="mb-1">รหัสบัตรประชาชน</label>
                      </div>

                      <b-button block variant="outline-primary" @click="getDataUser(form)">ค้นหา</b-button>
                    </b-col>
                  </b-row>
                </b-card>
                <hr>
                <b-row align-v="center" class="mb-2">
                  <b-col md="9" class="mb-2">
                    <b-pagination
                      v-model="currentPageReceipt"
                      :total-rows="totalRowsReceipt"
                      :per-page="200"
                      v-if="dataReady && totalRowsReceipt > 200"
                      @input="updatePage(currentPageReceipt)"
                      limit="7"
                      first-number
                      last-number
                      align="fill"
                      class="mb-0"
                    >
                      <template #prev-text><span>ย้อนกลับ</span></template>
                      <template #next-text><span>ถัดไป</span></template>
                    </b-pagination>
                  </b-col>
                  <b-col md="3" class="text-right mb-2">
                    <b>
                    <!-- ข้อมูลใบเสร็จ -->
                    ทั้งหมด {{totalRowsReceipt}} รายการ
                    </b>
                  </b-col>
                </b-row>

                <b-table table-variant="primary" small bordered striped hover :items="items" :fields="fields" :busy="!dataReady">

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>กำลังดึงข้อมูล...</strong>
                    </div>
                  </template>

                  <template #cell(firstlast)="data">
                    {{ data.item.fname }} {{ data.item.lname }}
                  </template>

                  <template #cell(facultymajor)="data">
                    {{ data.item.faculty }} {{ data.item.major }}
                  </template>

                  <template #cell(slip)="data">
                    <!-- {{ data.item.faculty }} {{ data.item.major }} -->
                    <b-button variant="primary" @click="openPDF(data.item.RefNo, data.item.sid)" size="sm">พิมพ์ใบเสร็จ</b-button>
                  </template>
                </b-table>
                
                <b-row align-v="center">
                  <b-col md="9" class="mb-2">
                    <b-pagination
                      v-model="currentPageReceipt"
                      :total-rows="totalRowsReceipt"
                      :per-page="200"
                      v-if="dataReady && totalRowsReceipt > 200"
                      @input="updatePage(currentPageReceipt)"
                      limit="7"
                      first-number
                      last-number align="fill"
                      class="mb-0"
                    >
                      <template #prev-text><span>ย้อนกลับ</span></template>
                      <template #next-text><span>ถัดไป</span></template>
                    </b-pagination>
                  </b-col>
                  <b-col md="3" class="text-right mb-2">
                    <b>
                    <!-- ข้อมูลใบเสร็จ -->
                    ทั้งหมด {{totalRowsReceipt}} รายการ
                    </b>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
            <b-tab title="ใบแจ้งการคืนเงิน (Refund Notice)">
              <b-card-text>
                <b-card sub-title="รายละเอียดการค้นหา">
                  <b-row>
                    <b-col md="3">
                      <div class="form-label-group">
                        <b-form-input placeholder="placeholder" id="form_stdname" autocomplete="off" class="mb-2" v-model="formNotice.fname" type="text"></b-form-input>
                        <label for="form_stdname" class="mb-1">ชื่อจริง</label>
                      </div>
                    </b-col>
                    <b-col md="3">
                      <div class="form-label-group">
                        <!-- :state="telState" aria-describedby="input-live-feedback" -->
                        <b-form-input placeholder="placeholder" id="form_stdname" autocomplete="off" class="mb-2" v-model="formNotice.lname" type="text"></b-form-input>
                        <label for="form_tel" class="mb-1">นามสกุล</label>
                      </div>
                    </b-col>
                    <b-col md="3">
                      <div class="form-label-group">
                        <b-form-input placeholder="placeholder" id="form_idstd" autocomplete="off" class="mb-2" v-model="formNotice.sid" type="tel"></b-form-input>
                        <label for="form_idstd" class="mb-1">รหัสนักศึกษา</label>
                        <!-- <b-form-text id="input-live-help">หากข้อมูลไม่ถูกต้องกรุณาติดต่อฝ่ายทะเบียน</b-form-text> -->
                      </div>
                    </b-col>
                    <b-col md="3">
                      <div class="form-label-group">
                        <!-- :state="telState" aria-describedby="input-live-feedback" -->
                        <b-form-input placeholder="placeholder" id="form_tel" autocomplete="off" class="mb-2" v-model="formNotice.cid" type="tel"></b-form-input>
                        <label for="form_tel" class="mb-1">รหัสบัตรประชาชน</label>
                      </div>

                      <b-button block @click="getDataUser(form)">ค้นหา</b-button>
                    </b-col>
                  </b-row>
                </b-card>
                <hr>
                <b-row align-v="center" class="mb-2">
                  <b-col md="9" class="mb-2">
                    <b-pagination
                      v-model="currentPageNotice"
                      :total-rows="totalRowsNotice"
                      :per-page="200"
                      v-if="dataReady && totalRowsNotice > 200"
                      @input="updatePageNotice(currentPageNotice)"
                      limit="7"
                      first-number
                      last-number
                      align="fill"
                      class="mb-0"
                      page-class="page-secondary"
                    >
                      <template #page="{ page, active }">
                        <span v-if="active">{{ page }}</span>
                        <span class="text-secondary" v-else>{{ page }}</span>
                      </template>
                      <template #prev-text><span class="text-secondary">ย้อนกลับ</span></template>
                      <template #next-text><span class="text-secondary">ถัดไป</span></template>
                    </b-pagination>
                  </b-col>
                  <b-col md="3" class="text-right mb-2">
                    <b>
                    <!-- ข้อมูลใบเสร็จ -->
                    ทั้งหมด {{totalRowsNotice}} รายการ
                    </b>
                  </b-col>
                </b-row>

                <b-table small bordered striped hover :items="itemsNotice" :fields="fields" :busy="!dataReady">

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>กำลังดึงข้อมูล...</strong>
                    </div>
                  </template>

                  <template #cell(firstlast)="data">
                    {{ data.item.fullname }}
                  </template>

                  <template #cell(facultymajor)="data">
                    {{ data.item.faculty }} {{ data.item.major }}
                  </template>

                  <template #cell(slip)="data">
                    <!-- {{ data.item.faculty }} {{ data.item.major }} -->
                    <b-button @click="openNoticePDF(data.item.RefNo, data.item.sid)" size="sm">พิมพ์ใบแจ้ง</b-button>
                  </template>
                </b-table>
                
                <b-row align-v="center">
                  <b-col md="9" class="mb-2">
                    <b-pagination
                      v-model="currentPageNotice"
                      :total-rows="totalRowsNotice"
                      :per-page="200"
                      v-if="dataReady && totalRows > 200"
                      @input="updatePageNotice(currentPageNotice)"
                      limit="7"
                      first-number
                      last-number align="fill"
                      class="mb-0"
                      page-class="page-secondary"
                    >
                      <template #page="{ page, active }">
                        <span v-if="active">{{ page }}</span>
                        <span class="text-secondary" v-else>{{ page }}</span>
                      </template>
                      <template #prev-text><span class="text-secondary">ย้อนกลับ</span></template>
                      <template #next-text><span class="text-secondary">ถัดไป</span></template>
                    </b-pagination>
                  </b-col>
                  <b-col md="3" class="text-right mb-2">
                    <b>
                    <!-- ข้อมูลใบเสร็จ -->
                    ทั้งหมด {{totalRowsNotice}} รายการ
                    </b>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>

      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import axios from 'axios' // api
export default {
  name: 'Register',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
    // document.body.className = 'login';
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด 
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    // this.getIPClient()

    this.getDataUser()
  },    
  computed: {
  },
  data () {
    return {
      dataReady: true,
      totalRowsReceipt: 200,
      currentPageReceipt: 1,
      totalRowsNotice: 200,
      currentPageNotice: 1,
      fields: [
        { key: 'RefNo', label: 'เลขที่ใบเสร็จ' },
        { key: 'sid', label: 'รหัสนักศึกษา' },
        { key: 'firstlast', label: 'ชื่อ - นามสกุล' },
        { key: 'cid', label: 'เลขบัตรประชาชน' },
        // { key: 'facultymajor', label: 'คณะ - สาขา' },
        { key: 'faculty', label: 'คณะ' },
        // { key: 'TransferDate', label: 'วันที่โอน' },
        { key: 'slip', label: 'ใบเสร็จ' }
      ],
      items: [ ],
      itemsNotice: [ ],
      adminData: {
        department: '',
        displayname_en: '',
        displayname_th: '',
        faculty: '',
        id_card: '',
        prefix_th: '',
        username: '',
        telephone: ''
      },
      formNotice: {
        // RefNo: "FUN00001",
        cid: "",
        // faculty: "",
        fname: "",
        lname: "",
        // major: "",
        sid: "",
      },
      form: {
        // RefNo: "FUN00001",
        cid: "",
        // faculty: "",
        fname: "",
        lname: "",
        // major: "",
        sid: "",
      }
    }
  },
  methods: {
    getDataUser () {
      let dt = this.getDataSessionUser()
      if (dt) {
        this.adminData = dt
        this.getDataList()
        this.getDataNotice()
      } else {
        this.$router.push('/StaffLogin')
      }
    },
    getDataList (startIndex) {
      this.dataReady = false
      let dt = { username: this.adminData.username }
      let hk = this.getHashKey(dt, 'Scholar_slip')
      let header = {
        'application-key': this.headerAPI['application-key'] + hk
      }
      let si = 1
      if (startIndex) {
        si = startIndex
      }

      // var x = '&username=' + dt.username
      var param = ''
      for(var key in this.form){
        // console.log(key,this.form[key])
        if (this.form[key]){
          param += "&" + key + "=" + this.form[key]
        }
      }
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://restapi.tu.ac.th/tu_covid_api/Scholar_slip/list_data?username=' + dt.username + param + '&start=' + si,
          {
            headers: header
          }
        )
        .then((response) => {
          // console.log('getDataList', response.data)
          let rs = response.data
          if (rs.status === true) {
            this.items = rs.objStudent
            this.totalRowsReceipt = rs.objStudent[0].total
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลนักศึกษาได้","error")
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('getDataUser error:', error)
          this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลนักศึกษาได้","error")
          // this.$swal("ผิดพลาด","เนื่องจากมีผู้ใช้งานเป็นจำนวนมาก กรุณารอประมาณ 10 นาทีแล้วจึงทำรายการใหม่อีกครั้ง","error")
          this.dataReady = true
        })
    },
    getDataNotice (startIndex) {
      this.dataReady = false
      let dt = { username: this.adminData.username }
      let hk = this.getHashKey(dt, 'refund_notice')
      let header = {
        'application-key': this.headerAPI['application-key'] + hk
      }
      let si = 1
      if (startIndex) {
        si = startIndex
      }

      // var x = '&username=' + dt.username
      var param = ''
      for(var key in this.form){
        // console.log(key,this.form[key])
        if (this.form[key]){
          param += "&" + key + "=" + this.form[key]
        }
      }
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://restapi.tu.ac.th/tu_covid_api/Refund/Refund_notice_list?username=' + dt.username + param + '&start=' + si,
          {
            headers: header
          }
        )
        .then((response) => {
          // console.log('getDataList', response.data)
          let rs = response.data
          if (rs.status === true) {
            this.itemsNotice = rs.objStudent
            this.totalRowsNotice = rs.objStudent[0].total
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลนักศึกษาได้","error")
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('getDataUser error:', error)
          this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลนักศึกษาได้","error")
          // this.$swal("ผิดพลาด","เนื่องจากมีผู้ใช้งานเป็นจำนวนมาก กรุณารอประมาณ 10 นาทีแล้วจึงทำรายการใหม่อีกครั้ง","error")
          this.dataReady = true
        })
    },
    openPDF (ref, sid) {
      let id = this.getHashKey(ref, sid)
      var urlPDF = 'https://restapi.tu.ac.th/tu_covid_api/Print_scholar_Slip/pdf?id='+ id +'&RefNo=' + ref + '&sid=' + sid
      window.open(urlPDF)
    },
    openNoticePDF (ref, sid) {
      let dt = { username: sid }
      let id = this.getHashKey(dt, 'refund_notice')
      var urlPDF = 'https://restapi.tu.ac.th/tu_covid_api/Print_refund_notice/Refund_notice?id='+ id + '&sid=' + sid
      window.open(urlPDF)
    },
    onSubmit (event) {
      let chkData = true
      event.preventDefault()

      if (this.confirmRequest) {
      } else {
        this.$swal("ผิดพลาด","กรุณาเลือกความประสงค์ของท่าน","error")
        chkData = false
      }

      if (this.form.telephone) {
      } else {
        this.$swal("ผิดพลาด","กรุณากรอกเบอร์โทรติดต่อกลับ","error")
        chkData = false
      }

      // if (this.form.email) {
      // } else {
      //   this.$swal("ผิดพลาด","กรุณากรอกอีเมลติดต่อกลับ","error")
      //   chkData = false
      // }

      if (chkData) {
        let textConfirm = ''
        if(this.confirmRequest === '1') {
          textConfirm = '<b class="text-success" style=" font-size: 1.2rem; ">ขอยืนยันสิทธิรับส่วนลดค่าเล่าเรียนและค่าธรรมเนียมการศึกษา</b>' 
        }
        if(this.confirmRequest === '2') {
          textConfirm = '<b class="text-danger" style=" font-size: 1.2rem; ">ไม่ขอรับส่วนลดค่าเล่าเรียนและค่าธรรมเนียมการศึกษา</b>' 
        }
        // this.registerClaim()
        let timeNow = new Date().getTime()
        // if (timeNow > 1632070800000 && timeNow < 1632675599000) {
          this.$swal({
            title: 'กรุณาตรวจสอบก่อนยืนยันสิทธิ์',
            html: "ท่านทำการเลือก " + textConfirm + " ยืนยันว่าถูกต้องใช่หรือไม่",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'ยืนยันสิทธิ์ที่เลือก',
            cancelButtonText: 'ยกเลิก กลับไปเลือกใหม่'
            // reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              this.checkData()
            } else {
              this.$swal(
                'ยกเลิก',
                'กรุณาเลือกความประสงค์ของท่านใหม่อีกครั้ง',
                'info'
              )
            }
          })
        // } else {
        //   this.$swal({
        //     titleText: "",
        //     html: 'เปิดระบบขอเลือกรับสิทธิ์ หรือแก้ไขการเลือกรับสิทธิ์<br>ภายใน <b>วันที่ 20 กันยายน 2564 เวลา 00:00 น.</b><br>ถึง <b>วันที่ 27 กันยายน 2564 เวลา 23:59 น.</b> เท่านั้น',
        //     icon: "info"
        //   })
          
        //   this.$router.push('/')
        // }
      }
    },
    updatePage (page) {
      // console.log('Page', page)
      let startIndex = (page - 1) * 200 + 1
      console.log('Page', startIndex)
      this.getDataList(startIndex)
    },
    updatePageNotice (page) {
      // console.log('Page', page)
      let startIndex = (page - 1) * 200 + 1
      console.log('Page', startIndex)
      this.getDataNotice(startIndex)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-login{
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Refund/SearchSlips.vue